import { useCallback } from "react";
import { useAxiosInstances } from "../axios-instance";

export interface IRefreshTokenResponse {
  Autenticado: boolean;
  Token: string;
  Mensagem: string;
}

export interface ISessionConfigResponse {
  result: {
    sessionTimeoutSeconds: number;
    refreshIntervalSeconds: number;
  };
}

export interface IAcessoResponse {
  acesso: {
    IdAcesso: number;
    IdUsuario: number;
    IdProduto: number;
    IPCliente: string;
    Inclusao?: Date;
    Atualizacao?: Date | null;
  };
  accessToken: string;
  usuario: {
    IdUsuario: number;
    IdCliente: number;
    Nome: string;
    LoginUsuario: string;
    Email: string;
    Ativo: boolean;
  };
}

export interface IInsertAcessoParams {
  IdProduto: number;
  IdUsuario: number;
}

export const useAuthRepository = () => {
  const { axiosAuthInstance } = useAxiosInstances();

  const getSessionConfig = useCallback(async (): Promise<ISessionConfigResponse> => {
    const response = await axiosAuthInstance.get<ISessionConfigResponse>("/auth/session-config");
    return response.data;
  }, [axiosAuthInstance]);

  const refreshToken = useCallback(async (token: string): Promise<IRefreshTokenResponse> => {
    const authUrl = process.env.REACT_APP_VELES_AUTH_URL;
    const response = await axiosAuthInstance.get<IRefreshTokenResponse>(`${authUrl}/api/validation/refreshTokenv3`, {
      headers: { Authorization: `Bearer ${token}` },
      skipAuthRedirect: true,
    });
    return response.data;
  }, [axiosAuthInstance]);

  const insertAcessoApi = useCallback(async (data: IInsertAcessoParams): Promise<IAcessoResponse> => {
    const response = await axiosAuthInstance.post<IAcessoResponse>("/auth/acesso", data);
    return response.data;
  }, [axiosAuthInstance]);

  return {
    getSessionConfig,
    refreshToken,
    insertAcessoApi,
  };
};

